
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2c90"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2c90"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $96648233ed719047$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["dHgyn","index.ac9c7748.js","3piFS","memorytile-beep.80d5ed15.mp3","b857U","applause-sound.db1c2c2e.mp3","5flMN","applause-1.6fb96cce.gif","bf4xo","applause-2.1cb0fbb3.gif","nfRbc","applause-3.4ebe40a3.gif","a9697","applause-4.3e0e6d2f.gif"]'));

var $100cb5227178f1e4$exports = {};
$100cb5227178f1e4$exports = new URL("applause-1.6fb96cce.gif", import.meta.url).toString();


var $a6c7b21df1eb47cf$exports = {};
$a6c7b21df1eb47cf$exports = new URL("applause-2.1cb0fbb3.gif", import.meta.url).toString();


var $60f74bb92e32fcea$exports = {};
$60f74bb92e32fcea$exports = new URL("applause-3.4ebe40a3.gif", import.meta.url).toString();


var $2cd17ee77cb6c5cd$exports = {};
$2cd17ee77cb6c5cd$exports = new URL("applause-4.3e0e6d2f.gif", import.meta.url).toString();


"use strict";
var $d932d33973552a6c$exports = {};
$d932d33973552a6c$exports = new URL("memorytile-beep.80d5ed15.mp3", import.meta.url).toString();


/* imports sounds*/ const $4f5514033b9926b2$var$tileBeep = new URL($d932d33973552a6c$exports);
var $1b6d1d163c144af5$exports = {};
$1b6d1d163c144af5$exports = new URL("applause-sound.db1c2c2e.mp3", import.meta.url).toString();


const $4f5514033b9926b2$var$applause = new URL($1b6d1d163c144af5$exports);
/* sound effects */ const $4f5514033b9926b2$var$memoryTileBeep = new Audio($4f5514033b9926b2$var$tileBeep);
$4f5514033b9926b2$var$memoryTileBeep.volume = 0.2;
const $4f5514033b9926b2$var$applauseSound = new Audio($4f5514033b9926b2$var$applause);
$4f5514033b9926b2$var$applauseSound.volume = 0.5;
/* DOM variables */ /* ------------------------------------------------- */ const $4f5514033b9926b2$var$startGame = document.querySelector(".start-game");
const $4f5514033b9926b2$var$quitBtn = document.querySelector(".btn-quit");
const $4f5514033b9926b2$var$previousBtn = document.querySelector(".btn-previous");
const $4f5514033b9926b2$var$memoryBlockArea = document.querySelector(".memory-block-area");
const $4f5514033b9926b2$var$memoryBlock = document.getElementsByClassName("memory-block");
const $4f5514033b9926b2$var$highScoreEL = document.querySelector(".high-score-number");
const $4f5514033b9926b2$var$currentScoreEL = document.querySelector(".current-score-number");
const $4f5514033b9926b2$var$messageBox = document.querySelector(".message-text");
const $4f5514033b9926b2$var$highScoreMessage = document.querySelector(".high-score-text");
const $4f5514033b9926b2$var$highScoreModal = document.getElementById("high-score-modal");
const $4f5514033b9926b2$var$highScoreNumberModal = document.querySelector(".high-score-number-modal");
const $4f5514033b9926b2$var$highScoreModalGif = document.querySelector(".high-score-applause-gif");
const $4f5514033b9926b2$var$gridCol = document.getElementsByClassName("grid-col");
const $4f5514033b9926b2$var$easyDifficulty = document.getElementById("easy");
const $4f5514033b9926b2$var$mediumDifficulty = document.getElementById("medium");
const $4f5514033b9926b2$var$hardDifficulty = document.getElementById("hard");
const $4f5514033b9926b2$var$customDifficulty = document.getElementById("custom");
const $4f5514033b9926b2$var$difficultySelectMenu = document.getElementById("difficulty-select-menu");
const $4f5514033b9926b2$var$customDifficultyMenu = document.getElementById("custom-difficulty");
const $4f5514033b9926b2$var$gameArea = document.getElementById("game-area");
const $4f5514033b9926b2$var$amountCustomDifficulty = document.getElementById("amount-custom-difficulty");
const $4f5514033b9926b2$var$nextCustomDifficulty = document.querySelector(".custom-difficulty-next");
const $4f5514033b9926b2$var$messageBoxCustom = document.querySelector(".message-custom-tiles");
let $4f5514033b9926b2$var$screenWidth = screen.width;
let $4f5514033b9926b2$var$numberOfTiles = 6;
let $4f5514033b9926b2$var$generatedNumbersSequence = [];
let $4f5514033b9926b2$var$playerNumbersSequence = [];
let $4f5514033b9926b2$var$memoryTiles = [];
let $4f5514033b9926b2$var$currentScore = 0;
let $4f5514033b9926b2$var$highScore = 0;
let $4f5514033b9926b2$var$playerTurn = false;
let $4f5514033b9926b2$var$computerTurn = false;
let $4f5514033b9926b2$var$newHighScore = false;
let $4f5514033b9926b2$var$gameAreaActive = false;
/* Difficulty select */ /* ------------------------------------------------- */ /* link the selected difficulty with the appropriate amount of memory tiles*/ $4f5514033b9926b2$var$easyDifficulty.addEventListener("click", function() {
    $4f5514033b9926b2$var$numberOfTiles = 4;
    $4f5514033b9926b2$var$prepareGame();
    $4f5514033b9926b2$var$toGameArea();
});
$4f5514033b9926b2$var$mediumDifficulty.addEventListener("click", function() {
    $4f5514033b9926b2$var$numberOfTiles = 9;
    $4f5514033b9926b2$var$prepareGame();
    $4f5514033b9926b2$var$toGameArea();
});
$4f5514033b9926b2$var$hardDifficulty.addEventListener("click", function() {
    $4f5514033b9926b2$var$numberOfTiles = 15;
    $4f5514033b9926b2$var$prepareGame();
    $4f5514033b9926b2$var$toGameArea();
});
$4f5514033b9926b2$var$customDifficulty.addEventListener("click", function() {
    $4f5514033b9926b2$var$toCustomDifficulty();
});
/* function that prepares the game by creating memory tiles in the html document, applies selectors to them,  creates the eventlistener event for when the players clicks the buttons and then moves to the game area */ function $4f5514033b9926b2$var$prepareGame() {
    $4f5514033b9926b2$var$createMemoryTilesHtml();
    $4f5514033b9926b2$var$createMemoryTilesSelector();
    $4f5514033b9926b2$var$createPlayerInputArray();
    $4f5514033b9926b2$var$styleColumnsGameArea();
    $4f5514033b9926b2$var$playerTurn = false;
    $4f5514033b9926b2$var$computerTurn = true;
    $4f5514033b9926b2$var$gameAreaActive = true;
}
/* function that navigates to the game area */ function $4f5514033b9926b2$var$toGameArea() {
    $4f5514033b9926b2$var$gameArea.classList.toggle("active-window");
    $4f5514033b9926b2$var$difficultySelectMenu.classList.toggle("active-window");
}
/* function that navigates between the  difficulty selection menu and custom difficulty  */ function $4f5514033b9926b2$var$toCustomDifficulty() {
    $4f5514033b9926b2$var$difficultySelectMenu.classList.toggle("active-window");
    $4f5514033b9926b2$var$customDifficultyMenu.classList.toggle("active-window");
}
/* return from custom difficulty to custom difficulty menu*/ $4f5514033b9926b2$var$previousBtn.addEventListener("click", function() {
    $4f5514033b9926b2$var$messageBoxCustom.innerHTML = "";
    $4f5514033b9926b2$var$toCustomDifficulty();
});
/* submit the amount of custom tiles the player wants to play with */ $4f5514033b9926b2$var$nextCustomDifficulty.addEventListener("click", function() {
    $4f5514033b9926b2$var$getCustomDifficultyInput();
});
/* validates the input and saves the player input to the numberOfTiles variable */ function $4f5514033b9926b2$var$getCustomDifficultyInput() {
    if ($4f5514033b9926b2$var$amountCustomDifficulty.value < 2) $4f5514033b9926b2$var$messageBoxCustom.innerHTML = "Please select more tiles";
    if (100 < $4f5514033b9926b2$var$amountCustomDifficulty.value && 581 < $4f5514033b9926b2$var$screenWidth) $4f5514033b9926b2$var$messageBoxCustom.innerHTML = "Please select less tiles";
    if (2 <= $4f5514033b9926b2$var$amountCustomDifficulty.value && $4f5514033b9926b2$var$amountCustomDifficulty.value <= 100 && 581 < $4f5514033b9926b2$var$screenWidth) {
        $4f5514033b9926b2$var$numberOfTiles = $4f5514033b9926b2$var$amountCustomDifficulty.value;
        $4f5514033b9926b2$var$messageBoxCustom.innerHTML = "";
        $4f5514033b9926b2$var$prepareGame();
        /* moves to the game area */ $4f5514033b9926b2$var$customDifficultyMenu.classList.toggle("active-window");
        $4f5514033b9926b2$var$gameArea.classList.toggle("active-window");
    }
    /* allow up 50 tiles tiles for a viewport width less than 581px */ if (50 < $4f5514033b9926b2$var$amountCustomDifficulty.value && 581 >= $4f5514033b9926b2$var$screenWidth) $4f5514033b9926b2$var$messageBoxCustom.innerHTML = "Please select less tiles";
    if (2 <= $4f5514033b9926b2$var$amountCustomDifficulty.value && $4f5514033b9926b2$var$amountCustomDifficulty.value <= 50 && 581 >= $4f5514033b9926b2$var$screenWidth) {
        $4f5514033b9926b2$var$numberOfTiles = $4f5514033b9926b2$var$amountCustomDifficulty.value;
        $4f5514033b9926b2$var$messageBoxCustom.innerHTML = "";
        $4f5514033b9926b2$var$prepareGame();
        /* moves to the game area */ $4f5514033b9926b2$var$customDifficultyMenu.classList.toggle("active-window");
        $4f5514033b9926b2$var$gameArea.classList.toggle("active-window");
    }
}
/* game area */ /* ------------------------------------------------- */ /* create a div in the html document with the memory tile properties. This is done an equal amount of times based on the requested amount of memory tiles by the player or selected difficulty setting  */ function $4f5514033b9926b2$var$createMemoryTilesHtml() {
    for(let i = 1; i <= $4f5514033b9926b2$var$numberOfTiles; ++i){
        const createMemoryTile = document.createElement("div");
        $4f5514033b9926b2$var$memoryBlockArea.appendChild(createMemoryTile);
        if ($4f5514033b9926b2$var$numberOfTiles <= 21) createMemoryTile.classList.add("memory-block", "memory-block-height--10", `memory-block--${i}`);
        if ($4f5514033b9926b2$var$numberOfTiles <= 70 && 21 < $4f5514033b9926b2$var$numberOfTiles) createMemoryTile.classList.add("memory-block", "memory-block-height--5", `memory-block--${i}`);
        if ($4f5514033b9926b2$var$numberOfTiles <= 100 && 70 < $4f5514033b9926b2$var$numberOfTiles) createMemoryTile.classList.add("memory-block", "memory-block-height--3", `memory-block--${i}`);
    }
}
/* debounce function to delay the next button press */ function $4f5514033b9926b2$var$debounce(func, timeout = 300) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(this, args);
        }, timeout);
    };
}
function $4f5514033b9926b2$var$saveInput() {
    console.log("Saving data");
}
const $4f5514033b9926b2$var$processChange = $4f5514033b9926b2$var$debounce(()=>$4f5514033b9926b2$var$saveInput());
/* loop that creates memory tiles based on the selected amount by the player */ function $4f5514033b9926b2$var$createMemoryTilesSelector() {
    for(let i = 1; i <= $4f5514033b9926b2$var$numberOfTiles; ++i)$4f5514033b9926b2$var$memoryTiles[i] = document.querySelector(`.memory-block--${i}`);
}
/* function that toggles the active memory tile */ function $4f5514033b9926b2$var$toggleMemoryTile(t) {
    $4f5514033b9926b2$var$memoryTiles[t].classList.toggle("active");
}
/* press the start button to start the game*/ $4f5514033b9926b2$var$startGame.addEventListener("click", function(number) {
    $4f5514033b9926b2$var$startGameSequence();
});
function $4f5514033b9926b2$var$startGameSequence() {
    if ($4f5514033b9926b2$var$playerTurn === false && $4f5514033b9926b2$var$computerTurn === true) {
        /* generate a random rumber which will be used to select a random memory tile*/ const generatedNumber = Math.floor(Math.random() * $4f5514033b9926b2$var$numberOfTiles) + 1;
        $4f5514033b9926b2$var$generatedNumbersSequence.push(generatedNumber);
        /* disable the start buttons while the sequence is running*/ $4f5514033b9926b2$var$computerTurn = false;
        /* loop that starts the play sequence */ for(let i = 0; i <= $4f5514033b9926b2$var$generatedNumbersSequence.length; i++){
            /* function that starts the play sequence with a timer*/ setTimeout(function() {
                $4f5514033b9926b2$var$messageBox.innerHTML = "";
                for(let t = 1; t <= $4f5514033b9926b2$var$numberOfTiles; ++t)if ($4f5514033b9926b2$var$generatedNumbersSequence[i] === t) {
                    $4f5514033b9926b2$var$toggleMemoryTile(t);
                    $4f5514033b9926b2$var$memoryTileBeep.play();
                    setTimeout(function() {
                        $4f5514033b9926b2$var$toggleMemoryTile(t);
                    }, 700);
                }
            /* code that sets the time in ms before the next button is shown */ }, 1000 * i);
            /* activate the buttons for the player after the computer has shown the order sequence*/ if (i === $4f5514033b9926b2$var$generatedNumbersSequence.length) setTimeout(function() {
                $4f5514033b9926b2$var$playerTurn = true;
                /* message the player it's their turn */ $4f5514033b9926b2$var$messageBox.innerHTML = `Repeat the sequence (${$4f5514033b9926b2$var$generatedNumbersSequence.length - $4f5514033b9926b2$var$playerNumbersSequence.length} remaining)`;
            }, 1000 * i);
        }
    }
}
/* function that creates multiple events (depending on the selected amount of tiles) for when the player clicks the memory tile buttons to repeat the asked sequence*/ function $4f5514033b9926b2$var$createPlayerInputArray() {
    for(let t = 1; t <= $4f5514033b9926b2$var$numberOfTiles; ++t)$4f5514033b9926b2$var$memoryTiles[t].addEventListener("click", function() {
        if ($4f5514033b9926b2$var$playerTurn === true) {
            $4f5514033b9926b2$var$playerNumbersSequence.push(t);
            /* show the remaining amount of buttons that player has yet to press to complete the sequence*/ $4f5514033b9926b2$var$messageBox.innerHTML = `Repeat the sequence (${$4f5514033b9926b2$var$generatedNumbersSequence.length - $4f5514033b9926b2$var$playerNumbersSequence.length} remaining)`;
            $4f5514033b9926b2$var$winCheck();
            /* Highlights the memorytile after the player has pressed it*/ $4f5514033b9926b2$var$toggleMemoryTile(t);
            $4f5514033b9926b2$var$memoryTileBeep.play();
            setTimeout(function() {
                $4f5514033b9926b2$var$toggleMemoryTile(t);
            }, 300);
        }
    });
}
/* function to check if the player has succesfully input the correct sequence*/ function $4f5514033b9926b2$var$winCheck() {
    /* check if enough buttons have been pressed by the player to match the amount the computer has input */ if ($4f5514033b9926b2$var$playerNumbersSequence.length === $4f5514033b9926b2$var$generatedNumbersSequence.length) {
        /* prepare for next round */ $4f5514033b9926b2$var$playerTurn = false;
        $4f5514033b9926b2$var$computerTurn = true;
        /* compare arrays */ if (JSON.stringify($4f5514033b9926b2$var$playerNumbersSequence) === JSON.stringify($4f5514033b9926b2$var$generatedNumbersSequence)) {
            /* message player they are correct */ $4f5514033b9926b2$var$messageBox.innerHTML = "You are correct!";
            /* update score */ $4f5514033b9926b2$var$currentScore++;
            $4f5514033b9926b2$var$updateCurrentScore();
            /* check high score & update it if appropriate*/ if ($4f5514033b9926b2$var$currentScore > $4f5514033b9926b2$var$highScore) {
                $4f5514033b9926b2$var$highScore = $4f5514033b9926b2$var$currentScore;
                $4f5514033b9926b2$var$updateHighScore();
                $4f5514033b9926b2$var$newHighScore = true;
                /* message the player they got a new high score */ $4f5514033b9926b2$var$highScoreMessage.innerHTML = "New high score!";
            }
            /* reset playerInput */ $4f5514033b9926b2$var$playerNumbersSequence = [];
        } else $4f5514033b9926b2$var$lostTheGame();
    }
    if ($4f5514033b9926b2$var$playerNumbersSequence.length !== $4f5514033b9926b2$var$generatedNumbersSequence.length) {
        for(let i = 0; i < $4f5514033b9926b2$var$playerNumbersSequence.length; i++)if ($4f5514033b9926b2$var$generatedNumbersSequence[i] !== $4f5514033b9926b2$var$playerNumbersSequence[i]) $4f5514033b9926b2$var$lostTheGame();
    }
}
/* losing the game function*/ function $4f5514033b9926b2$var$lostTheGame() {
    /* message player they are incorrect */ $4f5514033b9926b2$var$messageBox.innerHTML = "You are incorrect... try again";
    /* reset high score text */ $4f5514033b9926b2$var$highScoreMessage.innerHTML = "";
    if ($4f5514033b9926b2$var$newHighScore === true && 1 < $4f5514033b9926b2$var$highScore) {
        /* show high score popup modal */ $4f5514033b9926b2$var$ShowHideHighScoreModal();
        $4f5514033b9926b2$var$highScoreNumberModal.innerHTML = $4f5514033b9926b2$var$highScore;
        /* select random gif via a number of 1 to 4*/ const randomGif = Math.floor(Math.random() * 4) + 1;
        /* select the correct gif based on the randomly selected number*/ if (randomGif === 1) $4f5514033b9926b2$var$highScoreModalGif.src = (0, (/*@__PURE__*/$parcel$interopDefault($100cb5227178f1e4$exports)));
        if (randomGif === 2) $4f5514033b9926b2$var$highScoreModalGif.src = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b21df1eb47cf$exports)));
        if (randomGif === 3) $4f5514033b9926b2$var$highScoreModalGif.src = (0, (/*@__PURE__*/$parcel$interopDefault($60f74bb92e32fcea$exports)));
        if (randomGif === 4) $4f5514033b9926b2$var$highScoreModalGif.src = (0, (/*@__PURE__*/$parcel$interopDefault($2cd17ee77cb6c5cd$exports)));
        /* play applause sound effect */ $4f5514033b9926b2$var$applauseSound.play();
        $4f5514033b9926b2$var$applauseSound.loop = true;
        $4f5514033b9926b2$var$newHighScore = false;
    }
    /* update score */ $4f5514033b9926b2$var$currentScore = 0;
    $4f5514033b9926b2$var$updateCurrentScore();
    /* prepare for next round */ $4f5514033b9926b2$var$playerTurn = false;
    $4f5514033b9926b2$var$computerTurn = true;
    /* reset game*/ $4f5514033b9926b2$var$playerNumbersSequence = [];
    $4f5514033b9926b2$var$generatedNumbersSequence = [];
}
/* functions that updates the scores in the html document*/ /*  update the current score  */ function $4f5514033b9926b2$var$updateCurrentScore() {
    $4f5514033b9926b2$var$currentScoreEL.innerHTML = $4f5514033b9926b2$var$currentScore;
}
/*  update the high score  */ function $4f5514033b9926b2$var$updateHighScore() {
    $4f5514033b9926b2$var$highScoreEL.innerHTML = $4f5514033b9926b2$var$highScore;
}
/* high score modal */ /* hide the modal once the player clicked it*/ $4f5514033b9926b2$var$highScoreModal.addEventListener("click", function() {
    $4f5514033b9926b2$var$ShowHideHighScoreModal();
});
function $4f5514033b9926b2$var$ShowHideHighScoreModal() {
    $4f5514033b9926b2$var$highScoreModal.classList.toggle("active-window");
    $4f5514033b9926b2$var$applauseSound.pause();
    $4f5514033b9926b2$var$applauseSound.currentTime = 0;
}
/* style the columns so all the memory tiles fit on the screen */ function $4f5514033b9926b2$var$styleColumnsGameArea() {
    /* styling for 6 tiles or less */ if ($4f5514033b9926b2$var$numberOfTiles <= 6) {
        $4f5514033b9926b2$var$memoryBlockArea.className = "memory-block-area margin--30 gap--3 grid-col";
        $4f5514033b9926b2$var$gridCol[0].style.gridTemplateColumns = `repeat(2, 1fr)`;
    }
    /* styling for tiles between the numbers 6 and 21 */ for(let i = 2; i < 7; i++)if ($4f5514033b9926b2$var$numberOfTiles <= i * 3 + 3 && i * 3 < $4f5514033b9926b2$var$numberOfTiles) {
        $4f5514033b9926b2$var$memoryBlockArea.className = `memory-block-area margin--${40 - i * 5} gap--3 grid-col`;
        $4f5514033b9926b2$var$gridCol[0].style.gridTemplateColumns = `repeat(${i + 1}, 1fr)`;
    }
    /* styling for tiles between the numbers 22 and 25 */ if ($4f5514033b9926b2$var$numberOfTiles <= 25 && 21 < $4f5514033b9926b2$var$numberOfTiles) {
        $4f5514033b9926b2$var$memoryBlockArea.className = "memory-block-area margin--30 gap--2 grid-col";
        $4f5514033b9926b2$var$gridCol[0].style.gridTemplateColumns = `repeat(5, 1fr)`;
    }
    /* styling for tiles between the numbers 26 and 70*/ for(let i = 1; i < 10; i++)if ($4f5514033b9926b2$var$numberOfTiles <= 25 + i * 5 && 20 + i * 5 < $4f5514033b9926b2$var$numberOfTiles) {
        $4f5514033b9926b2$var$memoryBlockArea.className = `memory-block-area gap--2 grid-col`;
        $4f5514033b9926b2$var$gridCol[0].style.gridTemplateColumns = `repeat(${i + 5}, 1fr)`;
        /* select margin that's appriopriate for the number of tiles*/ if ($4f5514033b9926b2$var$numberOfTiles <= 35 && 25 < $4f5514033b9926b2$var$numberOfTiles) $4f5514033b9926b2$var$memoryBlockArea.classList.add("margin--30");
        if ($4f5514033b9926b2$var$numberOfTiles <= 50 && 35 < $4f5514033b9926b2$var$numberOfTiles) $4f5514033b9926b2$var$memoryBlockArea.classList.add("margin--20");
        if ($4f5514033b9926b2$var$numberOfTiles <= 60 && 50 < $4f5514033b9926b2$var$numberOfTiles) $4f5514033b9926b2$var$memoryBlockArea.classList.add("margin--15");
        if ($4f5514033b9926b2$var$numberOfTiles <= 70 && 60 < $4f5514033b9926b2$var$numberOfTiles) $4f5514033b9926b2$var$memoryBlockArea.classList.add("margin--10");
    }
    /* styling for tiles between the numbers 70 and 100*/ for(let i = 1; i < 4; i++)if ($4f5514033b9926b2$var$numberOfTiles <= 70 + i * 10 && 60 + i * 10 < $4f5514033b9926b2$var$numberOfTiles) {
        $4f5514033b9926b2$var$memoryBlockArea.className = `memory-block-area margin--${40 - i * 10} gap--1 grid-col`;
        $4f5514033b9926b2$var$gridCol[0].style.gridTemplateColumns = `repeat(${5 + i * 5}, 1fr)`;
    }
}
/* quit the game */ /* ------------------------------------------------- */ /* quit te game, reset all setting to default and return to the difficult select screen */ $4f5514033b9926b2$var$quitBtn.addEventListener("click", function() {
    $4f5514033b9926b2$var$removeMemoryTilesHtml();
    $4f5514033b9926b2$var$currentScore = 0;
    $4f5514033b9926b2$var$updateCurrentScore();
    $4f5514033b9926b2$var$highScore = 0;
    $4f5514033b9926b2$var$updateHighScore();
    $4f5514033b9926b2$var$generatedNumbersSequence = [];
    $4f5514033b9926b2$var$playerNumbersSequence = [];
    $4f5514033b9926b2$var$highScoreMessage.innerHTML = "";
    $4f5514033b9926b2$var$messageBox.innerHTML = "Press start to begin the game";
    $4f5514033b9926b2$var$gameAreaActive = false;
    $4f5514033b9926b2$var$toGameArea();
});
/* remove the generated memory tiles in the html document to reset the game */ function $4f5514033b9926b2$var$removeMemoryTilesHtml() {
    for(let i = 1; i <= $4f5514033b9926b2$var$numberOfTiles; ++i)$4f5514033b9926b2$var$memoryBlockArea.removeChild($4f5514033b9926b2$var$memoryBlockArea.lastElementChild);
}


//# sourceMappingURL=index.ac9c7748.js.map
